export default function GlobalStyle() {
  return (
    <style>{`
      @import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@400;500;600;700&family=JetBrains+Mono:wght@400;500;600;700&display=swap');
      * { box-sizing: border-box; -webkit-tap-highlight-color: transparent; }
      input::-ms-reveal,
      input::-ms-clear {
        display: none !important;
      }
      body { margin: 0; }
      @keyframes livePulse {
        0% { box-shadow: 0 0 0 0 rgba(91,140,255,0.55); }
        70% { box-shadow: 0 0 0 6px rgba(91,140,255,0); }
        100% { box-shadow: 0 0 0 0 rgba(91,140,255,0); }
      }
      @keyframes liveChartsPulse {
        0% { box-shadow: 0 0 0 0 rgba(109,91,208,0.55); }
        70% { box-shadow: 0 0 0 6px rgba(109,91,208,0); }
        100% { box-shadow: 0 0 0 0 rgba(109,91,208,0); }
      }
      @keyframes gradientDrift {
        0%   { transform: translate(-15%, -10%) scale(1); }
        25%  { transform: translate(20%, 10%) scale(1.15); }
        50%  { transform: translate(10%, 25%) scale(0.95); }
        75%  { transform: translate(-20%, 5%) scale(1.1); }
        100% { transform: translate(-15%, -10%) scale(1); }
      }
      @keyframes gradientDrift2 {
        0%   { transform: translate(15%, 15%) scale(1); }
        33%  { transform: translate(-15%, -10%) scale(1.1); }
        66%  { transform: translate(-5%, 20%) scale(0.9); }
        100% { transform: translate(15%, 15%) scale(1); }
      }
      @keyframes pjSpin {
        to { transform: rotate(360deg); }
      }
    `}</style>
  );
}